import { FloorTable } from "./floor-table";
import { PersonAccount } from "./person-account";
import { SystemField } from "./system-field";

export class CustomerReservation extends SystemField { 
    table_id?:string;
    customer_id?:string;
    reserve_date?:string;
    reserve_time?:string;
    status?:string;

    customer?:PersonAccount;
    table?:FloorTable;
}
